








































































import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import WebUserAuthCard from '@/modules/user/components/web/auth/WebUserAuthCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import AuthRoute from '@/modules/user/routes/auth.route'
import Copyright from '@/modules/shared/components/panel/Copyright.vue'
import Logo from '@/modules/shared/components/shared/Logo.vue'
import { Prop } from 'vue-property-decorator'
import WebLayout from '@/modules/common/layout/components/web/WebLayout.vue'
import { UserPasswordResetUpdateModel } from '@/modules/user/models/user-request.model'
import { AuthService } from '@/modules/user/services/auth.service'


@Component({
  layout: WebLayout,
  metaInfo: {
    title: 'تغییر رمز عبور'
  },
  components: { Logo, Copyright, Checkbox, WebUserAuthCard, BaseCard, Heading, BaseInput, BaseButton }
})
export default class ChangePasswordPage extends Vue {
  constructor(
    private readonly routes: AuthRoute,
    private readonly services: AuthService
  ) {
    super()
  }

  @Prop() email!: string
  @Prop() token!: string

  resetPasswordModel: UserPasswordResetUpdateModel = {
    email: this.email,
    password: '',
    password_confirmation: '',
    token: this.token
  }

  $refs!: {
    resetPasswordForm: QForm
  }

  loading = false

  passwordReset() {
    this.loading = true
    this.$refs.resetPasswordForm.validate().then(success => {
      if (success) {
        this.services.passwordResetUpdate(this.resetPasswordModel).onFinish(() => {
          this.loading = false
        })
      } else this.loading = false
    })
  }

}
